import type { AgencySignupInput } from '@admitly/shared';
import { api } from './api.js';

/**
 * Public — submit a self-serve agency signup. The API always responds with a
 * neutral 202 `{ ok: true }` whether the email is new or already in flight, so
 * callers must show the same confirmation either way (non-enumerating).
 */
export async function submitAgencySignup(input: AgencySignupInput): Promise<{ ok: true }> {
  return api<{ ok: true }>('/auth/agency-signup', {
    method: 'POST',
    body: input,
    noRetry: true,
  });
}

/**
 * Public — verify a signup email via the token from the verification link.
 * Resolves to `{ ok: true }` on success; throws ApiError with a generic message
 * on any failure (invalid / expired / already used) — the API does not reveal
 * which, so the UI must show one generic error.
 */
export async function verifyAgencySignup(token: string): Promise<{ ok: true }> {
  return api<{ ok: true }>('/auth/agency-signup/verify', {
    method: 'POST',
    body: { token },
    noRetry: true,
  });
}
